export enum NoFavoritesTexts {
    TITLE = "Пока ничего нет",
    DESCRIPTION = "Добавляйте в избранное интересные объявления и они будут отображаться в этом разделе",
    LINK_TEXT = "К каталогу объявлений"
}